import { apiUrl } from 'config';
import UserProfile from "components/UserProfile/UserProfile";
import axios from 'axios';
import toast, { Toaster } from "react-hot-toast"
import API from './API';

export const getOrders = async (filters = {}) => {
    const token = await UserProfile.getToken();
    const response = await axios.get(`${apiUrl}admin/orders`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
        params: filters
    });
    return response.data
}

export const modifyOrder = async (modifiedOrder) => {
    const token = await UserProfile.getToken();
    try {
        const response = await axios.put(
            `${apiUrl}admin/orders`,
            modifiedOrder,
            {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "application/json",
                },
            }
        );
        toast.success(response.data.msg);
    }
    catch (error) {
        error.response.data?.msg ? toast.error(error.response.data.msg) : toast.error(error.response.data)
    }
};


export const reSyncOrderWithSylectus = async (id) => {
    const toastId = toast.loading("Sync in progress...");
    const url = "" + "admin/get_order_dimensions";

    let formData = new FormData();
    formData.append("id", id);

    const response = await API.postData(url, formData);
    const data = response;

    if (data.status == true) {
        toast.success(data.msg);
    } else {
        toast.error(data.msg);
    }
    toast.dismiss(toastId);
};

// Create an axios instance with a base URL and authentication header
const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${localStorage.getItem('access_token')}` // Assuming JWT auth
    }
});

export const ordersApi = {
    // Basic CRUD operations for bs-orders
    getAll: () => api.get('bs-orders/'),

    getDirectPickupOrders: (filters) => {
        const params = new URLSearchParams(filters).toString();
        return api.get('bs-orders/direct-pickup/?' + params);
    },

    getById: (id) => api.get(`bs-orders/${id}/`),
    create: (data) => api.post('bs-orders/', data),
    update: (id, data) => api.put(`bs-orders/${id}/`, data),
    delete: (id) => api.delete(`bs-orders/${id}/`),

    archive: (id) => api.post(`bs-orders/${id}/archive/`),
    // Add more custom endpoints as needed
    getOrdersWithSeals: (filters) => {
        const params = new URLSearchParams(filters).toString();
        return api.get(`bs-orders/orders-with-seals/?${params}`);
    }      
};

// Add request interceptor to include the token dynamically before each request
api.interceptors.request.use(async (config) => {
    const token = await UserProfile.getToken();
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;  // Include token in Authorization header
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});